import React, { useEffect } from 'react'
import { useUser } from 'hooks/users'
import Avatar from '../Profile/Avatar.js'
import { formatDistanceToNowStrict } from 'date-fns';
import NameButton from 'components/MainApp/Profile/nameButton.js';
import Actions from './Actions.js';
import 'stylesheets/MainAppStyles/Note.css'
import ReactMarkdown from 'react-markdown'
import remarkGfm from 'remark-gfm';
import remarkGemoji from 'remark-gemoji';
import NoteFile from 'components/MainApp/NewNote/NoteFile.js';
import { useMarkdownNoteFile } from 'hooks/notes.js';
import SpinnerLoading from '../Spiners/index.js';



const Note = ({ note }) => {
    const { uid, title, text, date, loadedFiles } = note
    const { user, isLoading: userLoading } = useUser(uid);

    const { setURL, getMarkdownFile, isLoading: markdownLoading, markdownText } = useMarkdownNoteFile()

    useEffect(() => {
        setURL(text)
        getMarkdownFile()
    }, [user])


    // useEffect(() => {
    //     console.log(markdownText)
    // }, [markdownText])

    if (userLoading) return <SpinnerLoading />
    return (
        <div className='note-main-container'>
            <div className='note-header-container'>
                <Avatar user={user} />
                <div className='note-header-info'>
                    <div className='header-user-info'>
                        <div className='header-user-basics'>
                            <NameButton user={user} />
                            <p>@{user.username}</p>
                        </div>
                        <p className='header-time'>Published {formatDistanceToNowStrict(date, false)} ago</p>
                    </div>
                </div>
            </div>
            <div className='note-content-container'>
                <h1 className='note-title'>
                    {title}
                </h1>
                {
                    loadedFiles.length !== 0 &&
                    loadedFiles.map(file => <NoteFile editMode={false} loadedFiles={loadedFiles} id={file.id} ext={file.ext} filePath={file.url} key={file.id} fileName={file.name} />)
                }
                {
                    !markdownLoading ? <ReactMarkdown className='line-break' children={markdownText} remarkPlugins={[remarkGfm, remarkGemoji]} /> : ''
                }
            </div>
            <Actions note={note} />
        </div>
    )
}

export default Note